import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { clientGoodToServerMap } from 'app/businessRules';
import { loadDataAction,loadDataSuccessAction,loadDataErrorAction } from 'modules/app/actions';
import { storeGood as storeGoodActions } from '../actions';
import { STORE_GOOD } from '../constants/actionTypes';
import { saveGood, updateGood } from '../repository';


function *_storeGood(action) {
    const {utrac, formData} = action;
    yield put(loadDataAction('storeGood'));
    const payload = clientGoodToServerMap(formData);

    try {
        let good;
        if (formData.id) {
            good = yield call(updateGood(utrac, payload));
        } else {
            good = yield call(saveGood(utrac, payload));
        }
        yield put(storeGoodActions.success(good));
        yield put(loadDataSuccessAction('storeGood', 'good.form.save.success'));
    } catch (error) {
        yield put(storeGoodActions.error(error));
        yield put(loadDataErrorAction('storeGood', {response: error.response, body: error.body, titleId:'good.form.save.failed'}, action));
    }

}


export function *storeGood() {
    yield takeLatest(STORE_GOOD.REQUEST, _storeGood);
}